import { render } from "./RegisterPinConfirmView.vue?vue&type=template&id=318e437f"
import script from "./RegisterPinConfirmView.vue?vue&type=script&lang=js"
export * from "./RegisterPinConfirmView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__